import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bell, User, ChevronDown } from 'lucide-react';
interface TopbarProps {
  onAIClick?: () => void;
}
const Topbar: React.FC<TopbarProps> = ({
  onAIClick
}) => {
  const navigate = useNavigate();
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  return <header className="sticky top-0 z-20 bg-white border-b border-gray-200 shadow-sm" data-id="element-1599">
      <div className="px-4 py-3 flex items-center gap-4" data-id="element-1600">
        {/* Right side - Actions */}
        <div className="flex items-center gap-3 ml-auto" data-id="element-1601">
          <button className="rounded-full p-2 text-gray-500 hover:bg-gray-100 relative" title="Notifiche" data-id="element-1602">
            <Bell className="h-5 w-5" data-id="element-1603" />
            <span className="absolute top-1 right-1 h-2 w-2 rounded-full bg-red-500" data-id="element-1604"></span>
          </button>

          <div className="relative" data-id="element-1605">
            <button className="flex items-center gap-2 pl-2 border-l border-gray-200 hover:bg-gray-50 rounded-lg px-3 py-2 transition-colors" onClick={() => setShowAccountMenu(!showAccountMenu)} data-id="element-1606">
              <div className="h-8 w-8 rounded-full bg-greenback flex items-center justify-center text-white font-semibold" data-id="element-1607">
                AG
              </div>
              <span className="text-sm font-medium text-gray-900 hidden md:block" data-id="element-1608">
                Admin Greenback
              </span>
              <ChevronDown className="h-4 w-4 text-gray-500" data-id="element-1609" />
            </button>

            {showAccountMenu && <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50" data-id="element-1610">
                <a href="/profile" className="block px-4 py-2 text-sm font-normal text-gray-700 hover:bg-gray-50 rounded-t-lg" data-id="element-1611">
                  <div className="flex items-center" data-id="element-1612">
                    <User className="h-4 w-4 mr-2" data-id="element-1613" />
                    Profilo Admin
                  </div>
                </a>
                <div className="border-t border-gray-100" data-id="element-1614">
                  <button className="w-full text-left px-4 py-2 text-sm font-medium text-red-600 hover:bg-gray-50 rounded-b-lg" data-id="element-1615">
                    Esci
                  </button>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </header>;
};
export default Topbar;